const LangTurkeyFlag = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="11" viewBox="0 0 16 11" fill="none">
    <rect width="16" height="11" fill="#E30A17" />
    {/* Crescent: a white disc with an offset red disc punched out of it */}
    <circle cx="6.1" cy="5.5" r="2.4" fill="#F4F5F8" />
    <circle cx="7" cy="5.5" r="1.9" fill="#E30A17" />
    <path
      d="M10.2 3.9 10.63 5.22 12.02 5.22 10.9 6.04 11.33 7.36 10.2 6.54 9.07 7.36 9.5 6.04 8.38 5.22 9.77 5.22Z"
      fill="#F4F5F8"
    />
  </svg>
);

export default LangTurkeyFlag;
